import React, { useEffect } from "react";
import useApiHouse from "../api/useApiHouse";
import { useDispatch } from "react-redux";
import { addPaymentPayload, createReconShipmentPayload, fileReconJobPayload } from "../api/apiPayloads";
import { businessDaysFromDate } from "kx-common-components"
import { addReconShipment } from "../slices/reconShipmentsSlice";
import CopyFieldIcon from "../components/commonComponents/CopyFieldIcon";

const useCreateJob = (setDisplayMsg, setSecondOpen) => {
    const [createReconJobApi, {data, isLoading, error}] = useApiHouse();
    const [addPaymentDetails, {paymentData, paymentLoading, paymentErr}] = useApiHouse();
    const dispatch = useDispatch();
    const createReconJob = (importerCode, userGuid, reconciliationTypeCode, importerOfRecordNumber, importerOfRecordType, filerCode, importerEmail, processingPort, actionType, importEntryLocation, comment) => {
        createReconJobApi(createReconShipmentPayload(importerCode, userGuid, reconciliationTypeCode, importerOfRecordNumber, importerOfRecordType, filerCode, importerEmail, processingPort, actionType, importEntryLocation, comment));
    }
    useEffect(() => {
        if(!isLoading && data){
          const { eventMessage } = data;
          if(eventMessage?.code === 400){
            setDisplayMsg({color: "red", message: eventMessage?.response, title: "Something went wrong..."})
            setSecondOpen(true)
          } 
          else{
            dispatch(addReconShipment(eventMessage))
            addPaymentDetails(addPaymentPayload("2", businessDaysFromDate(new Date(Date.now()), 10).getTime(), eventMessage.reconShipmentId))
            setDisplayMsg({color: "black", message: <>New Recon Job &nbsp;<b>{eventMessage.shippingId}</b> <CopyFieldIcon fieldInfo={eventMessage.shippingId} />&nbsp; was created Successfully!</>, title: "Successfully Created New Recon Job"})
            setSecondOpen(true)
          }
        }
        if(error){
          setDisplayMsg({color: "red", message: JSON.stringify(error.data), title: "Something went wrong..."})
          setSecondOpen(true)
        }
      }, [isLoading, data, error])
    return { createReconJob, isLoading };
}
 
export default useCreateJob;